import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { debounce } from 'lodash';
import SearchIcon from '../../../../../icons/icon-search.svg';
import { Input } from '../../dls/components/input';
export var SearchInput = function (_a) {
    var placeholder = _a.placeholder, className = _a.className, name = _a.name, initialValue = _a.initialValue, onChange = _a.onChange, showIcon = _a.showIcon, setSearchTerm = _a.setSearchTerm;
    var _b = useState(initialValue !== null && initialValue !== void 0 ? initialValue : ''), inputValue = _b[0], setInputValue = _b[1];
    var callSetSearchTerm = useMemo(function () {
        return debounce(function (searchValue) {
            setSearchTerm(searchValue);
        }, 300);
    }, [setSearchTerm]);
    var handleChange = useCallback(function (event) {
        var value = event.target.value;
        setInputValue(value);
        callSetSearchTerm(value);
        if (onChange) {
            onChange();
        }
    }, [callSetSearchTerm, onChange]);
    var handleClear = useCallback(function () {
        handleChange({ target: { value: '' } });
    }, [handleChange]);
    return (_jsx("div", { className: "c-search-input", children: _jsx(Input, { className: className, name: name, placeholder: placeholder, startIcon: showIcon ? _jsx(SearchIcon, { className: "c-search-icon" }) : null, onChange: handleChange, value: inputValue, endIcon: inputValue !== '' ? (_jsx("button", { className: "c-search-input__clear", type: "button", onClick: handleClear, children: "\u00D7" })) : undefined }) }));
};
